/* eslint-disable prefer-promise-reject-errors */
import Axios from 'axios';

const environment = process.env;

const {
    REACT_APP_IMAGE_URL,
    REACT_APP_GLG_BASE_URL,
    REACT_APP_BASE_URL,
    REACT_APP_PORT_CONFIG,
    REACT_APP_PORT_ANALYTICS,
    REACT_APP_PORT_LICENSE,
    REACT_APP_PORT_SCADA,
} = environment;

export const ImageBaseURL = REACT_APP_IMAGE_URL;

export const glgBaseURL = REACT_APP_GLG_BASE_URL;


export const AppBaseURL = REACT_APP_BASE_URL;

export const baseURL = {
    0: `${AppBaseURL}/${REACT_APP_PORT_CONFIG}`,
    1: `${AppBaseURL}/${REACT_APP_PORT_ANALYTICS}`,
    2: `${AppBaseURL}/${REACT_APP_PORT_LICENSE}`,
    3: `${AppBaseURL}/${REACT_APP_PORT_SCADA}`,

};

const API = Axios.create({
    baseURL: baseURL[0],
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 30000,
});

API.interceptors.request.use(config => {
    if (config.baseIndex) {
        config.baseURL = baseURL[config.baseIndex];
    }
    config.headers['X-XSS-Protection'] = '1; mode=block';
    config.headers['Content-Security-Policy'] = "default-src 'self'; script-src 'self' 'unsafe-inline' 'unsafe-eval'; style-src 'self' 'unsafe-inline'; img-src 'self' data:; connect-src 'self'; font-src 'self';";
    // eslint-disable-next-line dot-notation
    config.headers['Referrer'] = 'no-referrer';
    config.headers['X-Content-Type-Options'] = 'nosniff';
    config.headers['Strict-Transport-Security'] = 'max-age=31536000; includeSubDomains; preload';
    config.headers['X-Frame-Options'] = 'SAMEORIGIN';
    return config;
});

API.interceptors.response.use(
    response => {
        if (response.status === 200 && response.data.status === 'fail') {
            return Promise.reject({
                error: response.data,
                message: response.data.response,
            });
        }
        return Promise.resolve(response.data);
    },
    error => Promise.reject(error),
);

export { API };
